export const todayIso = () => new Date().toISOString().slice(0, 10);

export const sisaHariKontrak = (k) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(k?.periode_selesai || ""));
  if (!m) return null;
  const end = Date.UTC(+m[1], +m[2] - 1, +m[3]);
  const now = new Date();
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((end - today) / 86400000);
};

export const isHabis = (k) => k.arsip === true || (!!k.periode_selesai && String(k.periode_selesai).slice(0, 10) < todayIso());

export const AKAN_HABIS_HARI = 60;
export const akanHabis = (k) => { const s = sisaHariKontrak(k); return !k.arsip && s !== null && s >= 0 && s <= AKAN_HABIS_HARI; };
